<script setup lang="ts">
import { OtTooltip, OtTooltipContent, OtTooltipTrigger } from './tooltip';

interface Props {
    title?: string;
    inverted?: boolean;
}
withDefaults(defineProps<Props>(), {
    inverted: false,
});
</script>

<template>
    <div class="flex relative pr-4 h-12 bg-stone-300 text-stone-800 container items-center" :class="{ inverted }">
        <ot-tooltip>
            <ot-tooltip-trigger class="ml-1 z-10">
                <slot name="icon" />
            </ot-tooltip-trigger>
            <ot-tooltip-content side="bottom">{{ title }}</ot-tooltip-content>
        </ot-tooltip>
        <div class="ml-2 mr-4">
            <div class="whitespace-nowrap"><slot name="upper" /></div>
            <div class="whitespace-nowrap"><slot name="lower" /></div>
        </div>
    </div>
</template>

<style scoped>
@reference "../css/onlinetennis.css";

.container:before {
    position: absolute;
    content: "";
    width: 22px;
    height: 100%;
    margin-left: -12px;
    transform: skew(-15deg);
    @apply bg-stone-300;
    @apply border-l;
    @apply border-neutral-900;
}
.container.inverted {
    background: transparent;
    @apply text-zinc-100;
    justify-content: center;
}
.container.inverted:before {
    content: normal;
}
</style>
